import { useAppSelector } from "@redux/hooks";
import { selectTeacherProfileRetrieval } from "@user-management-context/read/application/use-cases/teacher/teacher-profile-retrieval/selectors/teacher-profile-selectors";
import { TEACHER_STANDING } from "@user-management-context/read/domain/types/admin/teacher";

const STANDING_LEVELS: Record<TEACHER_STANDING, number> = {
  [TEACHER_STANDING.RESTRICTED]: 0,
  [TEACHER_STANDING.TRUSTED]: 1,
};

export const useTeacherStanding = () => {
  const { data: teacher } = useAppSelector(selectTeacherProfileRetrieval);

  const hasMinimumStanding = (required: TEACHER_STANDING): boolean => {
    if (!teacher) return false;
    return STANDING_LEVELS[teacher.standing] >= STANDING_LEVELS[required];
  };

  return { standing: teacher?.standing ?? null, hasMinimumStanding };
};
